import React from 'react';
import {
  Card,
  CardContent,
  Stack,
  Typography,
  Box,
  Icon
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const CartaoMetrica = ({ titulo, valor, variacao, cor = 'primary', icon: IconComponent }) => {
  const corBorde = cor === 'success' ? '#4caf50' : cor === 'warning' ? '#ff9800' : cor === 'error' ? '#f44336' : '#2196f3';
  const corFundo = cor === 'success' ? '#e8f5e9' : cor === 'warning' ? '#fff3e0' : cor === 'error' ? '#ffebee' : '#e3f2fd';

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  };

  const obterSeta = () => {
    if (variacao > 0) return <TrendingUpIcon sx={{ color: '#4caf50', fontSize: 20 }} />;
    if (variacao < 0) return <TrendingDownIcon sx={{ color: '#f44336', fontSize: 20 }} />;
    return null;
  };

  return (
    <Card
      sx={{
        borderLeft: `4px solid ${corBorde}`,
        backgroundColor: corFundo,
        height: '100%',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)'
        }
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>
              {titulo}
            </Typography>
            {IconComponent && <IconComponent sx={{ color: corBorde, fontSize: 24 }} />}
          </Box>

          <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#3e4095' }}>
            {formatarMoeda(valor)}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {obterSeta()}
            <Typography
              variant="caption"
              sx={{
                color: variacao > 0 ? '#4caf50' : variacao < 0 ? '#f44336' : '#999',
                fontWeight: 'bold'
              }}
            >
              {variacao > 0 ? '+' : ''}{variacao.toFixed(1)}%
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CartaoMetrica;
